import { orgPeopleList } from '@repo/domains-organization';
import { axios } from '@repo/http';
import { useMutation, useQueryClient } from '@tanstack/react-query';
/** @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md */ export function useDeleteOrganizationMember(param) {
    let { organization, organizationId, page, perPage } = param;
    const queryClient = useQueryClient();
    const { queryKey } = orgPeopleList.peopleList({
        organization,
        page,
        perPage
    });
    return useMutation({
        mutationFn: (memberId)=>axios.delete("/v2/people/".concat(organizationId, "/").concat(memberId)),
        onMutate: async (memberId)=>{
            await queryClient.cancelQueries({
                queryKey
            });
            const _peopleList = queryClient.getQueryData(queryKey);
            const filteredPeopleList = _peopleList === null || _peopleList === void 0 ? void 0 : _peopleList.entities.filter((item)=>item.id !== memberId);
            queryClient.setQueryData(queryKey, {
                entities: filteredPeopleList,
                meta: _peopleList === null || _peopleList === void 0 ? void 0 : _peopleList.pageMetadata
            });
            return {
                filteredPeopleList
            };
        },
        onSettled: async ()=>{
            await queryClient.invalidateQueries({
                queryKey
            });
        }
    });
}
